<div class="container-fluid" style="margin-bottom: 6em;">

  <p-dialog 
    #reportDialog
    [(visible)]="display"
    header="Report Request"
    class="report-modal"
    [baseZIndex]="1000" 
    [modal]="true"
    [contentStyle]="{'max-height':'80vh'}"
    (onHide)="dialogClosed()" >

      <div class="row">
        <iui-messages #iuimodalmsg mode="alert" class="ms-auto me-auto"></iui-messages>
      </div>
      <!-- <form #f="ngForm"> -->


          <div class="ui-g-9 mb-3 custom-form">
            <label class="required form-label" for="reportType">Report Type</label>
            <select required #reportType="ngModel" class="form-control" id="reportType" [(ngModel)]="reportTypeVal" name="reportType" (ngModelChange)="reportChange($event)">
              <option *ngFor="let opt of reportTypes" value="{{opt.value}}">{{opt.label}}</option>
            </select>
          </div>

          <!-- <div [ngSwitch]="reports.reportType"> -->
<!-- *****************************************TN Report************************************************************ -->
          <div [ngClass]="(reportTypeVal === 'tn')?'ui-g-12 mb-3 custom-form':'display-non'">
            <form #tnForm="ngForm">
              <div class="ui-g-12 mb-3 custom-form" >
                <div class="ui-g-10 mb-3 custom-form" >
                  <label class="required form-label" for="reportNameByTn">Report Name</label>
                  <input required #reportNameByTn="ngModel" type="text" class="form-control" [ngClass]="(tnReport.reportNameValid=== true)?'form-control':'form-control invalid-input-box'" 
                    id="reportNameByTn" maxlength="100" [(ngModel)]="tnReport.report.reportName" name="reportNameByTn">
                  <div class="input-msgs" [ngClass]="(tnReport.reportNameValid=== true)?'input-msgs':'input-msgs-error'">Max length of 100 characters. Must not start with space, period, hyphen, or underline. Must not include ~ " # % & : < > * / \ ? {{'{'}} &#125; $ ! ' &#64; |</div>
                </div>
                <div class="ui-g-12 mb-3 custom-form" >
                  <label class="required form-label" id="tnFileLab">TN List</label>
                  <div [ngClass]="(inputParams.byTnFile.valid === true)?'gray-file-box':'red-file-box'">
                    <label id="btn-upload-tn-file" class="btn btn-default" for="fileElem">Choose File</label>
                    <!-- <p-fileUpload required name="fileElem" #fileElem id="fileElem" type="file" accept="csv/*, txt/*" (change)="processUploadedFile($event.target.files)"
                      customUpload="true"></p-fileUpload> -->
                    <input required name="fileElem" #fileElem ngModel id="fileElem" style="display:none" type="file" accept=".csv, .txt" (change)="processUploadedFile($event.target.files)">
                    <strong *ngIf="inputParams.byTnFile.tnFileName != ''" class="file-info one-long-line" id="upload-file-name">{{inputParams.byTnFile.tnFileName}}</strong>
                    <!-- <div *ngIf="inputParams.byTnFile.tnFileName != ''" id="upload-file-name" class="file-info one-long-line"><strong>{{inputParams.byTnFile.tnFileName}}</strong></div> -->
                    <label *ngIf="inputParams.byTnFile.tnFileName == ''" id="upload-file-name" class="file-info">No file chosen</label>
                    <div class="input-msgs">.csv or .txt file types only, with a maximum of 500,000 TNs. TNs must be comma or line separated and only 10 digits, not starting with 0 or 1.</div>
                  </div>
                  <div class="error-box"><b>{{inputParams.byTnFile.boldText}} </b>{{inputParams.byTnFile.errMsg}}</div>
                </div>
              </div>
              <div class="ui-g-12 button-bottom">
                  <button id="cancel-queue-btn-tn" type="button" class="btn btn-secondary cancel-queue-btn" (click)="cancelQueue()">Cancel</button>
                  <button id="queue-report-btn-tn" type="button" class="btn btn-default queue-report-btn" 
                    [class]="(tnForm.valid === true)?'btn btn-default queue-report-btn':'btn btn-default queue-report-btn btn-disabled'" [disabled]="!tnForm.valid" (click)="queueReport()">Request Report</button>
              </div>
            </form>
          </div>
<!-- *********************************************Block Report**************************************************** -->
          <div [ngClass]="(reportTypeVal === 'block')?'ui-g-12 mb-3 custom-form':'display-non'">
            <form #blockForm="ngForm">
              <div class="ui-g-10 mb-3 custom-form" >
                <label class="required form-label" for="reportNameByBlock">Report Name</label>
                <input required #reportNameByBlock="ngModel" type="text" class="form-control" [ngClass]="(blockReport.reportNameValid=== true)?'form-control':'form-control invalid-input-box'" 
                  id="reportNameByBlock" maxlength="100" [(ngModel)]="blockReport.report.reportName" name="reportNameByBlock">
                <div class="input-msgs" [ngClass]="(blockReport.reportNameValid=== true)?'input-msgs':'input-msgs-error'">
                  Max length of 100 characters. Must not start with space, period, hyphen, or underline. Must not include ~ " # % & : < > * / \ ? {{'{'}} &#125; $ ! ' &#64; |</div>
              </div>
              <div class="ui-g-10 custom-form" >
                <span id="portInfo" style="display: block">Port Activation Date Range 
                  <i class="fa-solid fa-circle-info text-accent3" pTooltip="Based on Eastern Timezone." 
                    tooltipPosition="top" tooltipZIndex="11010" tooltipStyleClass="date-tooltip"></i>
                </span>
                <!-- title="Based on Eastern Timezone." -->
                <div class="ui-g ui-fluid custom-form">
                  <div class="ui-md-4">
                    <label class="calander-label" for="startDate">Start</label>
                    <p-calendar class="report-date-cal" [inputStyle]="(blockReport.portDatesInvalid=== true) ? 
                      {'border-width':'1px 1px 1px 5px', 'border-color':'#ff0000', 'border-style':'solid'}:{'border':'solid 1px #797d82'}"
                      name="startDate" dateFormat="yy-mm-dd"  monthNavigator="true" yearNavigator="true" yearRange="1970:2050" placeholder="YYYY-MM-DD"
                      id="startDate" [(ngModel)]="blkFromDate" [maxDate]="maxDate" ></p-calendar>
                  </div>
                  <div class="ui-md-4">
                    <label class="calander-label" for="endDate">End</label>
                    <p-calendar class="report-date-cal" [inputStyle]="(blockReport.portDatesInvalid=== true) ? 
                      {'border-width':'1px 1px 1px 5px', 'border-color':'#ff0000', 'border-style':'solid'}:{'border':'solid 1px #797d82'}"
                      name="endDate" dateFormat='yy-mm-dd' monthNavigator="true" yearNavigator="true" yearRange="1970:2050" placeholder="YYYY-MM-DD"
                      id="endDate" [(ngModel)]="blkToDate" [maxDate]="maxDate"></p-calendar>
                  </div>
                  <div *ngIf="blockReport.portDatesInvalid" class="error-box"><b>{{DEFAULT_ERROR}} </b>{{PORT_DATE_ERROR}}</div>
                </div>
              </div>
              <div class="ui-g-12">
                <label class="required">Blocks</label>
                <div class="ui-g-12">
                  <div class="ui-g ui-fluid">
                    <div style="padding:0 1em 0 1em"><p-radioButton #radioEnter class="block-radio-button" value="enter" name="enter" [(ngModel)]="searchBy" label="Enter" ></p-radioButton></div>
                    <div style="padding:0 1em 0 1em"><p-radioButton #radioUpload class="block-radio-button" value="upload" name="upload" [(ngModel)]="searchBy" label="Upload" ></p-radioButton></div>
                  </div>
                </div>
              </div>
              <div>
                <div [ngClass]="(searchBy === 'enter')?'ui-g-12 mb-3 custom-form':'display-non'">
                    <textarea [ngClass]="(inputParams.byNpb.valid === true)?'gray-text-box':'red-text-box'"
                      [required]="searchBy === 'enter'" 
                      id="block" 
                      class="ui-g-12" 
                      #blockNumField 
                      [(ngModel)]="inputParams.byNpb.input" 
                      rows="5" cols="12" name="blockNumField" ></textarea>
                    <div class="input-msgs">Maximum of 500 blocks. Blocks must be comma or line separated, and only 7 digits, not starting with 0 or 1.</div>
                    <div class="error-box"><b>{{inputParams.byNpb.boldText}} </b>{{inputParams.byNpb.errMsg}}</div>
                </div>

                <div [ngClass]="(searchBy === 'upload')?'ui-g-12 mb-3 custom-form':'display-non'" >
                  <!-- <label class="required" id="tnFileLab">TN List</label> -->
                  <div [ngClass]="(inputParams.byNpbFile.valid === true)?'gray-file-box':'red-file-box'">
                    <label id="btn-upload-tn-file" class="btn btn-default" for="fileElemNpb">Choose File</label>
                    <input [required]="searchBy=='upload'" name="fileElemNpb" #fileElemNpb ngModel id="fileElemNpb" style="display:none" type="file" accept=".csv, .txt" (change)="processUploadedFileNpb($event.target.files)">
                    <strong *ngIf="inputParams.byNpbFile.tnFileName != ''" class="file-info one-long-line" id="upload-file-name">{{inputParams.byNpbFile.tnFileName}}</strong>
                    <!-- <div *ngIf="inputParams.byNpbFile.tnFileName != ''" id="upload-file-name" class="file-info one-long-line"><strong>{{inputParams.byNpbFile.tnFileName}}</strong></div> -->
                    <label *ngIf="inputParams.byNpbFile.tnFileName == ''" id="upload-file-name" class="file-info">No file chosen</label>
                    <div class="input-msgs">.csv or .txt file types only. Maximum of 500 blocks. Blocks must be comma or line separated, and only 7 digits, not starting with 0 or 1.</div>
                  </div>
                  <div class="error-box"><b>{{inputParams.byNpbFile.boldText}} </b>{{inputParams.byNpbFile.errMsg}}</div>
                </div>
              </div>

              <div class="ui-g-12 button-bottom">
                  <button id="cancel-queue-btn-block" type="button" class="btn btn-secondary cancel-queue-btn" (click)="cancelQueue()">Cancel</button>
                  <button id="queue-report-btn-block" type="button" class="btn btn-default queue-report-btn" 
                    [class]="(blockForm.valid === true)?'btn btn-default queue-report-btn':'btn btn-default queue-report-btn btn-disabled'" 
                    [disabled]="!blockForm.valid" (click)="queueReport()">Request Report</button>
              </div>
            </form>
          </div>
<!-- *********************************************LRN Report****************************************************** -->
          <div [ngClass]="(reportTypeVal === 'lrn')?'ui-g-12 mb-3 custom-form':'display-non'" >
            <form #lrnForm="ngForm">
            <div class="ui-g-10 mb-3 custom-form" >
                <label class="required form-label" for="reportNameByLrn">Report Name</label>
                <input required #reportNameByLrn="ngModel" type="text" class="form-control" [ngClass]="(lrnReport.reportNameValid=== true)?'form-control':'form-control invalid-input-box'" 
                  id="reportNameByLrn" maxlength="100" [(ngModel)]="lrnReport.report.reportName" name="reportNameByLrn">
                <div class="input-msgs" [ngClass]="(lrnReport.reportNameValid=== true)?'input-msgs':'input-msgs-error'">
                  Max length of 100 characters. Must not start with space, period, hyphen, or underline. Must not include ~ " # % & : < > * / \ ? {{'{'}} &#125; $ ! ' &#64; |</div>
            </div>
            <div class="ui-g-12 mb-3 custom-form">
              <label class="required form-label" for="lrnField">LRNs</label>
              <textarea [ngClass]="(inputParams.byLrns.valid === true)?'gray-text-box':'red-text-box'"
                required
                id="lrnField"
                class="ui-g-12" 
                #lrnField 
                [(ngModel)]="inputParams.byLrns.input" 
                rows="5" cols="12" name="lrnField" ></textarea>
              <div class="input-msgs">Maximum of 50 LRNs. LRNs must be comma or line separated, and only 10 digits, not starting with 0 or 1.</div>
              <div class="error-box"><b>{{inputParams.byLrns.boldText}} </b>{{inputParams.byLrns.errMsg}}</div>
            </div>
            <div class="ui-g-12 button-bottom">
                <button id="cancel-queue-btn-lrn" type="button" class="btn btn-secondary cancel-queue-btn" (click)="cancelQueue()">Cancel</button>
                <button id="queue-report-btn-lrn" type="button" class="btn btn-default queue-report-btn" 
                  [class]="(lrnForm.valid === true)?'btn btn-default queue-report-btn':'btn btn-default queue-report-btn btn-disabled'" 
                  [disabled]="!lrnForm.valid" (click)="queueReport()">Request Report</button>
            </div>
            </form>
          </div>

<!-- *****************************************************Port Out Activity********************************************************* -->
          <div [ngClass]="(reportTypeVal === 'portOutActivity')?'ui-g-12 mb-3 custom-form':'display-non'">
            <form #portOutActivity="ngForm">
              <div class="ui-g-10 mb-3 custom-form" >
                  <label class="required form-label" for="reportNameByPortOut">Report Name</label>
                  <input required #reportNameByPortOut="ngModel" type="text" class="form-control" [ngClass]="(portOutActivityReport.reportNameValid=== true)?'form-control':'form-control invalid-input-box'" 
                    id="reportNameByPortOut" maxlength="100" [(ngModel)]="portOutActivityReport.report.reportName" name="reportNameByPortOut">
                  <div class="input-msgs" [ngClass]="(portOutActivityReport.reportNameValid=== true)?'input-msgs':'input-msgs-error'">
                    Max length of 100 characters. Must not start with space, period, hyphen, or underline. Must not include ~ " # % & : < > * / \ ? {{'{'}} &#125; $ ! ' &#64; |</div>
              </div>

              <div class="ui-g-10 mb-3 custom-form">
                  <label class="required custom-form ui-g-6 form-label" for="portOutActivities">Port Out Activities</label>
                  <p-multiSelect required class="ui-g-12 custom-form m-select-custom portActivities" [options]="portOutActDisplay"
                      [(ngModel)]="portOutActivityReport.report.reportData.portActivityList" id="portOutActivities" name="portOutActivities" >

                    <ng-template let-portOutVal pTemplate="selectedItems" >
                      <ng-container *ngIf="portOutVal && portOutVal.length <= (portOutActDisplay.length - 3)">
                          <ng-container *ngFor="let val of portOutVal" >
                              <div class="ui-multiselected-item-token ui-corner-all">{{val}}</div>
                          </ng-container>
                      </ng-container>
                      <ng-container *ngIf="portOutVal && portOutVal.length === (portOutActDisplay.length - 2)">
                          <span class="ui-multiselected-empty-token ui-corner-all" >All</span>
                      </ng-container>
                      <span *ngIf="!portOutVal || portOutVal.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>
                      
                    </ng-template>
                  </p-multiSelect>
              </div>

              <div class="ui-g-10 mb-3 custom-form">
                  <label class="required ui-g-6 custom-form form-label" for="spidList">Company SPIDs</label>
                  <p-multiSelect required class="ui-g-12 custom-form m-select-custom" [options]="spidDisplay" 
                    [(ngModel)]="portOutActivityReport.report.reportData.spidList" id="spidList" name=" spidList">

                    <ng-template let-portOutSpidVal pTemplate="selectedItems" >
                        <ng-container *ngIf="portOutSpidVal && portOutSpidVal.length <= (spidDisplay.length - 1)">
                            <ng-container *ngFor="let val of portOutSpidVal" >
                                <div class="ui-multiselected-item-token ui-corner-all">{{getSpidLabel(val)}}</div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="portOutSpidVal && (spidDisplay?.length > 0) && portOutSpidVal.length === spidDisplay.length">
                            <span class="ui-multiselected-empty-token ui-corner-all" >All</span>
                        </ng-container>
                        <span *ngIf="!portOutSpidVal || portOutSpidVal.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>  
                    </ng-template>
                    
                  </p-multiSelect>
              </div>

              <div class="ui-g-10 mb-3 custom-form">
                  <label class="ui-g-12 custom-form form-label" for="regionList">Regions</label>
                  <p-multiSelect class="ui-g-5 custom-form m-select-custom" [options]="regionsDisplay" 
                    [(ngModel)]="portOutActivityReport.report.reportData.regionList" id="regionList" name="regionList">

                    <ng-template let-portOutRegionVal pTemplate="selectedItems" >
                        <ng-container *ngIf="portOutRegionVal && portOutRegionVal.length === 1">
                            <ng-container *ngFor="let val of portOutRegionVal" >
                                <div class="ui-multiselected-item-token ui-corner-all">{{getRegionLabel(val)}}</div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="portOutRegionVal && (portOutRegionVal.length > 1 && portOutRegionVal.length < regionsDisplay.length)">
                                <div class="ui-multiselected-item-token ui-corner-all">{{portOutRegionVal.length}} items selected</div>
                        </ng-container>
                        <ng-container *ngIf="portOutRegionVal && portOutRegionVal.length === regionsDisplay.length">
                            <span class="ui-multiselected-empty-token ui-corner-all" >All</span>
                        </ng-container>
                        <span *ngIf="!portOutRegionVal || portOutRegionVal.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>
                        
                      </ng-template>

                  </p-multiSelect>
              </div>

              <div class="ui-g-12 custom-form">
                  <label class="ui-g-4 custom-form" for="dateRange">Date Range 
                      <i class="fa-solid fa-circle-info text-accent3" pTooltip="Based on Eastern Timezone."
                        tooltipPosition="top" tooltipZIndex="130100" tooltipStyleClass="date-tooltip"></i>
                  </label>
                  <div *ngIf="portOutActivityReport.report.reportData.dateType === 'dateRange'" class="custom-form">
                      <label class="calander-label ui-g-3 custom-form" for="fromDatePortOut">Start</label>
                      <label class="calander-label ui-g-2 custom-form" for="toDatePortOut">End</label>
                  </div>
              </div>
              <div class="ui-g-12 mb-3 custom-form">
                  <div class="ui-g-3 custom-form" style="margin-right: 5%">
                    <p-dropdown class="ui-g-3 custom-form" [options]="dateRangeDisplay" 
                      [(ngModel)]="portOutActivityReport.report.reportData.dateType" id="dateRangePortOut" name="dateRange"></p-dropdown>
                  </div>
                  <div class="ui-g ui-fluid" *ngIf="portOutActivityReport.report.reportData.dateType === 'dateRange'">

                      <div class="ui-g-4 custom-form" style="margin: 0% 3%">
                        <p-calendar class="report-date-cal" [inputStyle]="(portOutActivityReport.portDatesInvalid=== true) ? 
                          {'border-width':'1px 1px 1px 5px', 'border-color':'#ff0000', 'border-style':'solid'}:{'border':'solid 1px #797d82'}"
                          name="fromDatePortOut" dateFormat="yy-mm-dd"  monthNavigator="true" yearNavigator="true" yearRange="1970:2050" placeholder="YYYY-MM-DD"
                          id="fromDatePortOut" [(ngModel)]="fromDatePortOut" [minDate]="minDate" [maxDate]="maxDate" ></p-calendar>
                      </div>

                      <div class="ui-g-4 custom-form">
                        <p-calendar class="report-date-cal" [inputStyle]="(portOutActivityReport.portDatesInvalid=== true) ? 
                          {'border-width':'1px 1px 1px 5px', 'border-color':'#ff0000', 'border-style':'solid'}:{'border':'solid 1px #797d82'}"
                          name="toDatePortOut" dateFormat='yy-mm-dd' monthNavigator="true" yearNavigator="true" yearRange="1970:2050" placeholder="YYYY-MM-DD"
                          id="toDatePortOut" [(ngModel)]="toDatePortOut" [minDate]="minDate" [maxDate]="maxDate"></p-calendar>
                      </div>

                      <div *ngIf="portOutActivityReport.portDatesInvalid" class="error-box"><b>{{DEFAULT_ERROR}} </b>{{PORT_DATE_ERROR}}</div>
                  </div>
              </div>

              <div class="ui-g-12 button-bottom" style="margin-top: 10%">
                  <button id="cancel-queue-btn" type="button" class="btn btn-secondary cancel-queue-btn" (click)="cancelQueue()">Cancel</button>
                  <button id="queue-report-btn" type="button" class="btn btn-default" 
                    [class]="(portOutActivity.valid === true)?'btn btn-default queue-report-btn':'btn btn-default queue-report-btn btn-disabled'" 
                    [disabled]="!portOutActivity.valid" (click)="queueReport()">Request Report</button>
              </div>
            </form>
          </div>

<!-- **************************************************Port In Activity************************************************************** -->
          <div [ngClass]="(reportTypeVal === 'portInActivity')?'ui-g-12 mb-3 custom-form':'display-non'">
            <form #portInActivity="ngForm">
              <div class="ui-g-10 mb-3 custom-form" >
                  <label class="required form-label" for="reportNameByPortIn">Report Name</label>
                  <input required #reportNameByPortIn="ngModel" type="text" class="form-control" [ngClass]="(portInActivityReport.reportNameValid=== true)?'form-control':'form-control invalid-input-box'" 
                    id="reportNameByPortIn" maxlength="100" [(ngModel)]="portInActivityReport.report.reportName" name="reportNameByPortIn">
                  <div class="input-msgs" [ngClass]="(portInActivityReport.reportNameValid=== true)?'input-msgs':'input-msgs-error'">
                    Max length of 100 characters. Must not start with space, period, hyphen, or underline. Must not include ~ " # % & : < > * / \ ? {{'{'}} &#125; $ ! ' &#64; |</div>
              </div>
              <div class="ui-g-10 mb-3 custom-form">
                <label class="required custom-form ui-g-6 form-label" for="portInActivities">Port In Activities</label>
                <p-multiSelect required class="ui-g-12 custom-form m-select-custom portActivities" [options]="portInActDisplay"
                    [(ngModel)]="portInActivityReport.report.reportData.portActivityList" id="portInActivities" name="portInActivities" >

                  <ng-template let-portInVal pTemplate="selectedItems" >
                    <ng-container *ngIf="portInVal && portInVal.length <= (portInActDisplay.length - 3)">
                        <ng-container *ngFor="let val of portInVal" >
                            <div class="ui-multiselected-item-token ui-corner-all">{{val}}</div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="portInVal && portInVal.length === (portInActDisplay.length - 2)">
                        <span class="ui-multiselected-empty-token ui-corner-all" >All</span>
                    </ng-container>
                    <span *ngIf="!portInVal || portInVal.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>
                    
                  </ng-template>
                </p-multiSelect>
              </div>
              <div class="ui-g-10 mb-3 custom-form">
                <label class="required ui-g-6 custom-form form-label" for="spidList">Company SPIDs</label>
                <p-multiSelect required class="ui-g-12 custom-form m-select-custom" [options]="spidDisplay" 
                  [(ngModel)]="portInActivityReport.report.reportData.spidList" id="spidList" name=" spidList">

                  <ng-template let-portInSpidVal pTemplate="selectedItems" >
                      <ng-container *ngIf="portInSpidVal && portInSpidVal.length <= (spidDisplay.length - 1)">
                          <ng-container *ngFor="let val of portInSpidVal" >
                              <div class="ui-multiselected-item-token ui-corner-all">{{getSpidLabel(val)}}</div>
                          </ng-container>
                      </ng-container>
                      <ng-container *ngIf="portInSpidVal && (spidDisplay?.length > 0) && (portInSpidVal.length === spidDisplay.length)">
                          <span class="ui-multiselected-empty-token ui-corner-all" >All</span>
                      </ng-container>
                      <span *ngIf="!portInSpidVal || portInSpidVal.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>  
                  </ng-template>
                  
                </p-multiSelect>
              </div>

              <div class="ui-g-10 mb-3 custom-form">
                <label class="ui-g-12 custom-form form-label" for="regionList">Regions</label>
                <p-multiSelect class="ui-g-5 custom-form m-select-custom" [options]="regionsDisplay" 
                  [(ngModel)]="portInActivityReport.report.reportData.regionList" id="regionList" name="regionList">

                  <ng-template let-portInRegionVal pTemplate="selectedItems" >
                      <ng-container *ngIf="portInRegionVal && portInRegionVal.length === 1">
                          <ng-container *ngFor="let val of portInRegionVal" >
                              <div class="ui-multiselected-item-token ui-corner-all">{{getRegionLabel(val)}}</div>
                          </ng-container>
                      </ng-container>
                      <ng-container *ngIf="portInRegionVal && (portInRegionVal.length > 1 && portInRegionVal.length < regionsDisplay.length)">
                              <div class="ui-multiselected-item-token ui-corner-all">{{portInRegionVal.length}} items selected</div>
                      </ng-container>
                      <ng-container *ngIf="portInRegionVal && portInRegionVal.length === regionsDisplay.length">
                          <span class="ui-multiselected-empty-token ui-corner-all" >All</span>
                      </ng-container>
                      <span *ngIf="!portInRegionVal || portInRegionVal.length === 0" class="ui-multiselected-empty-token ui-corner-all" style="color: #a3a7a9">Select</span>
                      
                    </ng-template>

                </p-multiSelect>
              </div>

              <div class="ui-g-12 custom-form">
                <label class="ui-g-4 custom-form" for="dateRange">Date Range 
                    <i class="fa-solid fa-circle-info text-accent3" pTooltip="Based on Eastern Timezone."
                      tooltipPosition="top" tooltipZIndex="130100" tooltipStyleClass="date-tooltip"></i>
                </label>
                <div *ngIf="portInActivityReport.report.reportData.dateType === 'dateRange'" class="custom-form">
                    <label class="calander-label ui-g-3 custom-form" for="fromDatePortOut">Start</label>
                    <label class="calander-label ui-g-2 custom-form" for="toDatePortOut">End</label>
                </div>
            </div>
            <div class="ui-g-12 mb-3 custom-form">
                <div class="ui-g-3 custom-form" style="margin-right: 5%">
                  <p-dropdown class="ui-g-3 custom-form" [options]="dateRangeDisplay" 
                    [(ngModel)]="portInActivityReport.report.reportData.dateType" id="dateRangePortOut" name="dateRange"></p-dropdown>
                </div>
                <div class="ui-g ui-fluid" *ngIf="portInActivityReport.report.reportData.dateType === 'dateRange'">

                    <div class="ui-g-4 custom-form" style="margin: 0% 3%">
                      <p-calendar class="report-date-cal" [inputStyle]="(portInActivityReport.portDatesInvalid=== true) ? 
                        {'border-width':'1px 1px 1px 5px', 'border-color':'#ff0000', 'border-style':'solid'}:{'border':'solid 1px #797d82'}"
                        name="fromDatePortOut" dateFormat="yy-mm-dd"  monthNavigator="true" yearNavigator="true" yearRange="1970:2050" placeholder="YYYY-MM-DD"
                        id="fromDatePortOut" [(ngModel)]="fromDatePortIn"  [maxDate]="maxDate" ></p-calendar>
                    </div>

                    <div class="ui-g-4 custom-form">
                      <p-calendar class="report-date-cal" [inputStyle]="(portInActivityReport.portDatesInvalid=== true) ? 
                        {'border-width':'1px 1px 1px 5px', 'border-color':'#ff0000', 'border-style':'solid'}:{'border':'solid 1px #797d82'}"
                        name="toDatePortOut" dateFormat='yy-mm-dd' monthNavigator="true" yearNavigator="true" yearRange="1970:2050" placeholder="YYYY-MM-DD"
                        id="toDatePortOut" [(ngModel)]="toDatePortIn" [minDate]="minDate" [maxDate]="maxDate"></p-calendar>
                    </div>

                    <div *ngIf="portInActivityReport.portDatesInvalid" class="error-box"><b>{{DEFAULT_ERROR}} </b>{{PORT_DATE_ERROR}}</div>
                </div>
            </div>

              <div class="ui-g-12 button-bottom" style="margin-top: 10%">
                <button id="cancel-queue-btn" type="button" class="btn btn-secondary cancel-queue-btn" (click)="cancelQueue()">Cancel</button>
                <button id="queue-report-btn" type="button" class="btn btn-default" 
                  [class]="(portInActivity.valid === true)?'btn btn-default queue-report-btn':'btn btn-default queue-report-btn btn-disabled'" 
                  [disabled]="!portInActivity.valid" (click)="queueReport()">Request Report</button>
              </div>
            </form>
          </div>

  </p-dialog>

  <div class="row">
      <div class="col">
          <h3>Reports</h3>
          <div class="center">
              <iui-messages #iuimsg mode="alert" class="ms-auto me-auto"></iui-messages>
          </div>
      </div>
  </div>

  <div class="row">
    <div class="col">
      <button id="request-report-btn" class="btn btn-default" type="button" (click)="showDialog()" >Request Report</button>
    </div>
  </div>

  <iui-reportsqueuetable #reportsTable (recieveReports)="onTableRecieve($event)" [reportTypes]="reportTypes" [reportId]="reportParam"></iui-reportsqueuetable>


</div>